export interface IHippoContent {
    [key: string]: string;
}

export default function getHippoText(resourceBundles: Map<string, any> | null, identifier: string): IHippoContent {
    let content: IHippoContent = {};

    if (resourceBundles && resourceBundles.has(identifier)) {
        content = resourceBundles.get(identifier);
    } else {
        throw new Error(`Error occur when fetching: ${identifier}`);
    }
    return content;
}
